import { render, staticRenderFns } from "./FrequentlyScannedProductPopUp.vue?vue&type=template&id=054d001e&scoped=true"
import script from "./FrequentlyScannedProductPopUp.vue?vue&type=script&lang=js"
export * from "./FrequentlyScannedProductPopUp.vue?vue&type=script&lang=js"
import style0 from "./FrequentlyScannedProductPopUp.vue?vue&type=style&index=0&id=054d001e&prod&scoped=true&lang=css"
import style1 from "./FrequentlyScannedProductPopUp.vue?vue&type=style&index=1&id=054d001e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d001e",
  null
  
)

export default component.exports